import {useContext} from 'react';
import {MyContext} from "../DataContext/DataContext";

const useStore = () => {
    // @ts-ignore
    return useContext(MyContext);
};

export default useStore;
